<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Notificaciones"   />

    <Notifications />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import Notifications from "@/components/Pages/Admin/Notifications/index.vue";

export default defineComponent({
  name: "NotificationsPage",
  components: {
    PageTitle,
    Notifications,
  },
});
</script>
